import {Controller} from "stimulus";

// Live character count for the social media post compose form. Counts
// the Trix editor's plain text (what actually gets sent to networks)
// and warns when the text exceeds the tightest selected provider limit.
export default class extends Controller {
    static targets = ["output", "editor", "account"];

    connect() {
        // Trix initializes asynchronously; count once it settles.
        setTimeout(() => this.update(), 100);
    }

    update() {
        if (!this.hasOutputTarget) return;

        const length = this.plainTextLength();
        this.outputTarget.textContent = `${length.toLocaleString()} characters`;

        const limit = this.tightestSelectedLimit();
        if (limit && length > limit) {
            this.outputTarget.classList.add("text-red-600", "font-medium");
            this.outputTarget.textContent += ` — over the ${limit.toLocaleString()} character limit`;
        } else {
            this.outputTarget.classList.remove("text-red-600", "font-medium");
        }
    }

    plainTextLength() {
        if (!this.hasEditorTarget || !this.editorTarget.editor) return 0;
        return this.editorTarget.editor.getDocument().toString().trim().length;
    }

    tightestSelectedLimit() {
        const limits = this.accountTargets
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => parseInt(checkbox.dataset.characterLimit, 10))
            .filter((limit) => !isNaN(limit));
        if (limits.length === 0) return null;
        return Math.min(...limits);
    }
}
